<template>
  <HeroView
      title="Force"
      text="Sales-optimized dark theme with conversion-driven design and high-impact features — designed to maximize sales opportunities and accelerate revenue growth."
      purchase-link="https://themes.shopify.com/themes/force/styles/force"
      preview-link="https://themes.shopify.com/themes/force/styles/force/preview"
      price="$380"
      img-main="/assets/imgs/themes/force/hero/hero@2x.webp"
      img-set="/assets/imgs/themes/force/hero/hero.webp 1x, /assets/imgs/themes/force/hero/hero@2x.webp 2x"
  />

  <DemosView
      title="5 Ready-Made <br>Profitable Layouts"
      text="Discover 5 effective layouts — engineered to enhance profitability and create high-impact customer experiences."
      theme-id="force"
  />

  <BannerView
      title="Create a Commerce Space That Sparks Real Results"
      text="Sales-focused from start to finish — with converting popups, featured product highlights, bold animated headings, strict grids, translucent sections, and smooth animations, all designed to engage and convert."
      purchase-link="https://themes.shopify.com/themes/force/styles/force"
      preview-link="https://themes.shopify.com/themes/force/styles/force/preview"
      price="$380"
      img-main="/assets/imgs/themes/force/banner@2x.webp"
      img-set="/assets/imgs/themes/force/banner.webp 1x, /assets/imgs/themes/force/banner@2x.webp 2x"
  />
  <FeaturesView/>

  <BuiltView/>
  <DocView
      doc-link="/help-center/documentation/force/"
      img-main="/assets/imgs/themes/force/doc/doc@2x.webp"
      img-set="/assets/imgs/themes/force/doc/doc.webp 1x, /assets/imgs/themes/force/doc/doc@2x.webp 2x"
  />
  <FinalView
      title="Achieve Higher Conversions with Force"
      text="Every feature is designed to increase conversions, drive sales, and maximize your growth potential."
      purchase-link="https://themes.shopify.com/themes/force/styles/force"
      preview-link="https://themes.shopify.com/themes/force/styles/force/preview"
      price="$380"
      img-main="/assets/imgs/themes/force/final@2x.webp"
      img-set="/assets/imgs/themes/force/final.webp 1x, /assets/imgs/themes/force/final@2x.webp 2x"
  />
</template>

<script>
import HeroView from '@/components/general/HeroView.vue'
import DemosView from '@/components/general/DemosView.vue'
import BannerView from '@/components/general/BannerView.vue'
import FeaturesView from '@/components/general/FeaturesView.vue'
import BuiltView from '@/components/general/BuiltView.vue'
import DocView from '@/components/general/DocView.vue'
import FinalView from '@/components/general/FinalView.vue'

export default {
  name: 'ForceView',
  components: {
    HeroView,
    DemosView,
    BannerView,
    FeaturesView,
    BuiltView,
    DocView,
    FinalView
  }
}
</script>
